export default __webpack_public_path__ + "static/media/filterIcon.033f7e30.svg";